<ng-container [ngSwitch]="disruptionMessage?.severity">
    <ng-container *ngSwitchCase="DisruptionMessageSeverity.CRITICAL">
        <div
            class="vl-app-light:mt-2 sr-app-light:bg-gray sr-app-light:mt-2 bg-grey-light var-app-dark:!bg-contrast-white orb-app-dark:!bg-contrast-white box-border flex w-full items-center overflow-hidden rounded-lg px-2.5 py-[7px] text-base">
            <ion-icon
                class="var-app-dark:text-black orb-app-dark:text-black text-red-alert_icon orb-app-light:text-red-alert_icon mr-3 h-9 w-9 shrink-0"
                [ngClass]="{ '!h-7 !w-7': env.IS_NEW_AFC }"
                src="{{ assetsPath$ | async }}/img/explore/icon-alert-circle.svg"></ion-icon>

            <div class="flex flex-1 items-center leading-5">
                <p
                    class="vl-app-light:line-clamp-2 vl-app-light:pr-2 sr-app-light:line-clamp-2 sr-app-light:pr-2 align-left flex-1 dark:text-black">
                    <span class="pr-1">{{
                        disruptionMessage.headerTextDefault | truncate: this.env.EXPLORE?.ALERTS_LIMIT_TITLE
                    }}</span>
                </p>
            </div>
        </div>
    </ng-container>
    <!-- WARNING (default) -->
    <ng-container *ngSwitchDefault>
        <button
            class="vl-app-light:mt-2 sr-app-light:bg-yellow-alert sr-app-light:mt-2 var-app-dark:!bg-contrast-white orb-app-dark:!bg-contrast-white box-border flex w-full items-center overflow-hidden rounded-lg bg-yellow-alert px-2.5 py-[7px] text-base"
            (click)="env.EXPLORE?.ALERTS_BUBBLE_CLICK && openDisruptionMessageDetailsView(disruptionMessage)">
            <ion-icon
                class="hu-light:!h-7 hu-light:!w-7 tartu-light:text-yellow-alert mr-3 h-9 w-9 shrink-0 text-black dark:text-contrast-white"
                [ngClass]="{ 'var-app-light:text-black !h-7 !w-7': env.IS_NEW_AFC }"
                src="{{ assetsPath$ | async }}/img/explore/alert-triangle-no-color.svg"></ion-icon>

            <div class="flex flex-1 items-center leading-5">
                <p
                    class="vl-app-light:line-clamp-2 vl-app-light:pr-2 sr-app-light:line-clamp-2 sr-app-light:pr-2 align-left flex-1 dark:text-black">
                    <span class="pr-1">{{
                        disruptionMessage.headerTextDefault | truncate: this.env.EXPLORE?.ALERTS_LIMIT_TITLE
                    }}</span>
                    <span class="inline-flex gap-1" *ngIf="this.env.EXPLORE?.ALERTS_SHOW_MORE">
                        {{ 'READ_MORE' | translate }}<ion-icon class="mt-0.5" name="arrow-forward-outline"></ion-icon>
                    </span>
                </p>
                <button
                    class="ml-auto inline-flex items-center gap-1 whitespace-pre text-inherit dark:text-contrast-black"
                    *ngIf="disruptionMessage.descriptionTextDefault && !env.EXPLORE?.ALERTS_BUBBLE_CLICK"
                    [attr.aria-label]="'READ_MORE' | translate"
                    (click)="openDisruptionMessageDetailsView(disruptionMessage)">
                    {{ 'READ_MORE' | translate }}<ion-icon class="mt-0.5" name="arrow-forward-outline"></ion-icon>
                </button>
                <span
                    class="pointer-events-none ml-auto inline-flex items-center gap-1 whitespace-pre text-inherit dark:text-contrast-black"
                    *ngIf="
                        disruptionMessage.descriptionTextDefault && env.EXPLORE?.ALERTS_BUBBLE_CLICK === 'arrow-only'
                    ">
                    <ion-icon class="mt-0.5" name="arrow-forward-outline"></ion-icon>
                </span>
            </div>
        </button>
    </ng-container>
    <ng-container *ngSwitchCase="DisruptionMessageSeverity.INFO">
        <div
            class="vl-app-light:mt-2 sr-app-light:bg-gray sr-app-light:mt-2 bg-grey-light var-app-dark:!bg-contrast-white orb-app-dark:!bg-contrast-white box-border flex w-full items-center overflow-hidden rounded-lg px-2.5 py-[7px] text-base">
            <ion-icon
                class="text-blue-alert_icon var-app-dark:text-black orb-app-dark:text-black mr-3 h-9 w-9 shrink-0"
                [ngClass]="{ '!h-7 !w-7': env.IS_NEW_AFC }"
                src="{{ assetsPath$ | async }}/img/explore/icon-info-no-color.svg"></ion-icon>

            <div class="flex flex-1 items-center leading-5">
                <p
                    class="vl-app-light:line-clamp-2 vl-app-light:pr-2 sr-app-light:line-clamp-2 sr-app-light:pr-2 align-left flex-1 dark:text-black">
                    <span class="pr-1">{{ disruptionMessage.descriptionTextDefault }}</span>
                </p>
            </div>
        </div>
    </ng-container>
</ng-container>
